export default "__VITE_ASSET__Dh9HI8WU__"